<template>
  <button
    v-for="(item, itemIdx) in items"
    :key="`tab-list-${itemIdx}`"
    class="border-b-4 text-sm duration-300 hover:text-cdp-black-500"
    :class="[
      item.value === selectTab
        ? 'rounded-tl-md rounded-tr-md border-b-cdp-main-primary font-medium text-cdp-black-500'
        : 'font-momo border-transparent text-[#606266]',
      dense ? 'min-w-[80px] py-2' : 'py-2 px-6'
    ]"
    @click="selectTab = item.value"
  >
    {{ item.text }}
  </button>
  <hr />
</template>

<script>
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'NavTab',
  props: {
    modelValue: {
      type: [String, Number],
      default: () => ''
    },
    items: {
      type: Array,
      default: () => [
        {
          text: String,
          value: Number
        }
      ]
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const selectTab = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
        emit('change', val);
      }
    });

    return {
      selectTab
    };
  }
});
</script>